import { useEffect, } from 'react';
import { AppBar, Toolbar, } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import InfoIcon from '@mui/icons-material/Info';
import { useAuth, useAppbar, } from '../../hooks';
import CustomContainer from '../custom-container';
import LogoDesktop from './LogoDesktop';
import LogoLessDesktop from './LogoLessDesktop';
import Menu from './Menu';
import ControlSwipeableDrawerMenu from './ControlSwipeableDrawerMenu';
import AuthButtons from './AuthButtons';
import AccountMenu from './AccountMenu';

const Header = () => {
    const { user, } = useAuth();
    const { scrollableTabsLibraryChange, } = useAppbar();

    const pages = [
        { name: 'Главная', link: user ? '/latest' : '/', icon: HomeIcon, },
        { name: 'Помощь', link: '/help', icon: HelpCenterIcon, },
        { name: 'О проекте', link: '/about', icon: InfoIcon, },
    ];

    useEffect(() => {
        scrollableTabsLibraryChange(undefined, 0);
    }, [user]);

    return (
        <>
            <AppBar elevation={1} position='fixed' sx={{ bgcolor: 'primary.main', }}>
                <CustomContainer>
                    <Toolbar disableGutters>
                        <LogoDesktop />
                        <ControlSwipeableDrawerMenu pages={pages} />
                        <LogoLessDesktop />
                        <Menu pages={pages} />
                        {user ? <AccountMenu /> : <AuthButtons />}
                    </Toolbar>
                </CustomContainer>
            </AppBar>
        </>
    );
};
export default Header;